// eslint-disable-next-line import/no-unresolved
import brand from '@brand/brand.js';
import clsx from 'clsx';
import CalendarIcon from 'jsx:../../assets/calendar-icon.svg';
import { Trans, useTranslation } from 'react-i18next';
import { BrandedLayout } from '../components/layouts/branded-layout';
import { Button } from '../components/ui/button';
import { InfoBlock } from '../components/ui/info-block';
import { useEnrichedInvite } from '../hooks/use-enriched-invite';
import { cleanPhone } from '../utils/phone';

export function InviteComplete() {
  const { t } = useTranslation('page.confirmation');
  const invite = useEnrichedInvite();
  const { icsFile } = invite;

  return (
    <BrandedLayout>
      <h1 className="title">
        <Trans
          i18nKey="title"
          t={t}
          values={invite}
          components={{
            br: <br />,
          }}
        />
      </h1>

      <Trans
        i18nKey="text"
        t={t}
        values={invite}
        components={{
          p: <p className="mb-2.5" />,
          strong: <strong className="font-semibold" />,
          Status: <strong className="font-semibold text-success-600" />,
        }}
      />

      <Button
        to={icsFile}
        type="button"
        variant="outlined"
        className={clsx('flex items-center justify-center gap-3', icsFile || 'hidden')}
        download
      >
        <CalendarIcon className="size-5 text-gray-500" />
      </Button>

      <InfoBlock className="!pt-2.5">
        <Trans
          i18nKey="confirmationText"
          t={t}
          components={{
            ul: <ul />,
            li: <li className="mt-0.5" />,
            h3: <h3 className="subtitle mb-0" />,
            strong: <strong className="font-semibold" />,
          }}
        />
      </InfoBlock>

      <InfoBlock>
        <Trans
          i18nKey="helpMessage"
          t={t}
          values={{ phone: brand.phone }}
          components={{
            h3: <h3 className="subtitle mb-0" />,
            p: <p />,
            br: <br />,
            strong: <strong className="font-semibold" />,
            a: <a href={`tel:${cleanPhone(brand.phone)}`} />,
          }}
        />
      </InfoBlock>
    </BrandedLayout>
  );
}
